import { StatusCadastroEnum } from "../enum";

export class CRMTag {
    id: number;
    tag: string;
    icone: string;
    cor: string;
    statusCadastro: StatusCadastroEnum = StatusCadastroEnum.Ativo;
}